/*

----------------------
     topbar
----------------------
       header
----------------------
              |
     main     |  side
              |
     tabs     |
-----------------------


 */
import React from "react";
import { withStyles } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { Classes, ThemeType } from "@theme";
import { SpinnerOverlay } from "@components";
import { withErrorBoundary } from "@components/error-boundary";

type OwnProps = {
  id: string;
  loading?: boolean;
  header?: React.ReactNode;
  main: React.ReactNode;
  side: React.ReactNode;
  topbar: React.ReactNode;
};

type Props = OwnProps & {
  classes: Classes<typeof styles>;
};

class CustomerProfileLayout extends React.Component<Props> {
  render() {
    const { classes, header, id, main, side, topbar } = this.props;

    return (
      <Grid
        container
        spacing={2}
        className={classes.root}
        data-test="CustomerProfileLayout"
        data-test-id={id}
      >
        <SpinnerOverlay show={this.props.loading} />

        <Grid item xs={12}>
          {withErrorBoundary(topbar)}
        </Grid>

        {header && (
          <Grid item xs={12}>
            {withErrorBoundary(header)}
          </Grid>
        )}

        <Grid item xs={12} md={8} lg={9} className={classes.main}>
          {withErrorBoundary(main)}
        </Grid>

        {side && (
          <Grid item xs={12} md={4} lg={3}>
            {withErrorBoundary(side)}
          </Grid>
        )}
      </Grid>
    );
  }
}

const styles = (theme: ThemeType) => ({
  root: {
    padding: theme.spacing(2),
    marginTop: -16
  },

  main: {
    flex: 1,

    [theme.breakpoints.down("sm")]: {
      order: 10
    },

    "& > div:not(:last-child)": {
      marginBottom: theme.spacing(2)
    }
  }
});

export default withStyles(styles as any)(
  CustomerProfileLayout
) as React.ComponentType<OwnProps>;
